import { render } from "./Warning.vue?vue&type=template&id=1d25b300"
import script from "./Warning.vue?vue&type=script&lang=ts"
export * from "./Warning.vue?vue&type=script&lang=ts"
script.render = render

export default script